module.exports = __webpack_public_path__ + "img/LUB00164.01474cea.png";